import classNames from 'classnames';
import { Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from '../../../../components/common/SubtleBadge';

export const usePendingIsDarkMode = () => useSelector((state) => Boolean(state.config?.isDark));

/**
 * 待办列表 Badge：浅色实心 Badge，深色 subtle Badge（Bootstrap 色板变量）
 */
export const PendingThemeBadge = ({ bg, pill, className, icon, iconProps, text, children }) => {
	const isDark = usePendingIsDarkMode();
	const content =
		children ??
		(
			<>
				{icon ? <FontAwesomeIcon icon={icon} className='me-1' {...iconProps} /> : null}
				{text != null && text !== '' ? <span className='fs-11'>{text}</span> : null}
			</>
		);

	if (!bg) {
		return null;
	}

	if (isDark) {
		return (
			<SubtleBadge bg={bg} pill={pill} className={className}>
				{content}
			</SubtleBadge>
		);
	}

	return (
		<Badge bg={bg} pill={pill} className={className}>
			{content}
		</Badge>
	);
};

/** 状态列（默认带 stream 图标） */
const PendingListStatusBadge = ({ bg, text, pill, className = 'me-2', showIcon = true, icon, iconProps }) => {
	if (!bg || !text || text === '-') {
		return null;
	}

	return (
		<PendingThemeBadge
			bg={bg}
			pill={pill}
			className={className}
			icon={showIcon ? icon ?? 'stream' : undefined}
			iconProps={iconProps}
			text={text}
		/>
	);
};

/** 列表顶部指标条：上标签、下金额；可点选筛选时用 active 区分 */
export const PendingStatChip = ({ label, value, active = true, onClick, title }) => {
	const interactive = typeof onClick === 'function';

	const handleKeyDown = (event) => {
		if (!interactive) return;
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			onClick(event);
		}
	};

	return (
		<div
			role={interactive ? 'button' : undefined}
			tabIndex={interactive ? 0 : undefined}
			title={title}
			onClick={onClick}
			onKeyDown={handleKeyDown}
			className={classNames('pending-stat-chip', {
				'pending-stat-chip--active': active,
				'pending-stat-chip--inactive': !active,
				'pending-stat-chip--interactive': interactive,
			})}
		>
			<span className='pending-stat-chip__label'>{label}</span>
			<span className='pending-stat-chip__value'>{value}</span>
		</div>
	);
};

export default PendingListStatusBadge;
